import { render } from "./EscalationViewModal.vue?vue&type=template&id=115c21c3"
import script from "./EscalationViewModal.vue?vue&type=script&lang=js"
export * from "./EscalationViewModal.vue?vue&type=script&lang=js"

import "./EscalationViewModal.vue?vue&type=style&index=0&id=115c21c3&lang=css"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__